import React, { FC, Fragment } from 'react';
import classNames from 'classnames';
import { compose } from '@reduxjs/toolkit';

import type { BettingContextProps } from '../../types';

import { withinBettingContext } from 'app/contexts/betting';
import { ArrowDivider, ArrowSize } from 'app/design-system/components/ArrowDivider';
import { SportId } from 'app/lib/betting/constants';
import { getSportKey } from 'app/lib/betting/sport-utils';
import { BreadcrumbType } from 'app/redux/betting-presentation/grid/constants';
import type { GridSubheaderBreadcrumbs } from 'app/redux/betting-presentation/grid/selectors';

import { getDataGaEventByNamespace } from '../../utils/data-ga-event-by-namespace';
import BreadCrumbLink from './BreadcrumbLink';

import styles from './Breadcrumb.module.scss';

export type GridSubheaderBreadcrumbProps = {
  breadcrumbs: GridSubheaderBreadcrumbs;
  sportId: SportId;
  className?: string;
  nonClickableSportsEvent?: boolean;
};

type ContextProps = {
  $betting: BettingContextProps;
};

const GridSubheaderBreadcrumb: FC<GridSubheaderBreadcrumbProps & ContextProps> = ({
  breadcrumbs,
  sportId,
  className,
  nonClickableSportsEvent,
  $betting: { namespace },
}) => {
  return (
    <div
      data-test="tournament-name"
      className={classNames(styles.tournamentName, styles[getSportKey(sportId)], className)} >
      <p>
        {breadcrumbs
          && breadcrumbs.map((breadcrumb) => {
            if (
              breadcrumb.type === BreadcrumbType.SPORT
            ) {
              return null;
            }

            return (
              <Fragment key={breadcrumb.type}>
                <BreadCrumbLink breadcrumb={breadcrumb}
                                dataGaEvent={getDataGaEventByNamespace(namespace, 'crumbsClick')}
                                nonClickableSportsEvent={nonClickableSportsEvent} />
                {breadcrumb.type !== BreadcrumbType.STAGE && (
                  <ArrowDivider icon="micro-chevron-right"
                                size={ArrowSize.BIG} />
                )}
              </Fragment>
            );
          })}
      </p>
    </div>
  );
};

export default compose<FC<GridSubheaderBreadcrumbProps>>(
  withinBettingContext,
)(GridSubheaderBreadcrumb);
